var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('br'),_c('br'),_c('v-btn',{staticClass:"red",attrs:{"dark":""},on:{"click":_vm.logout}},[_vm._v("Salir")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }